<template>
    <v-container fluid>
        <!-- inicio de cambiar de rancho -->
        <v-row class="pa-0 ma-0 align-center"
               justify="center"
               no-gutters>
            <v-col cols="8" justify="justify-center" class="ma-0 pa-0">
                <ChangeRanch
                    :paddock="paddockSelected"
                    :paddocks="currentPaddocks">
                </ChangeRanch>
            </v-col>
        </v-row>
        <!-- fin de cambiar de rancho -->

        <!-- inicio de texto principal -->
        <v-row class="my-3 px-2 smart-title-2 home-title-container-mobile"
               no-gutters>
            <v-col cols="12" class="d-flex align-center justify-center">
                <div class="unselectable" style="text-align:center">Esta es tu lista de vacas. Continua agregando tus vacas al sistema</div>
            </v-col>
        </v-row>
        <!-- fin de texto principal -->

        <!-- inicio de tarjeta de vacas en sistema -->
        <v-col cols="12" class="pa-0">
            <SystemCardCount height="40px"
                             width="100%"
                             number="100"
                             title-background="#57A7F5"
                             number-background="#1460AA"
                             title="Vacas en Sistema">
             </SystemCardCount>
          </v-col>
        <!-- fin de tarjeta de vacas en sistema -->

        <!-- inicio de contadores de animales -->
        <v-row no-gutters class="my-3">

            <!-- inicio de contadores de vaquillas -->
            <v-col cols="4" class="d-flex">
              <v-col class="pa-1 mr-2 full-height d-flex align-center std-animal-count-container justify-space-between std-background-white-1">
                <i class="std-icon std-heifer-blue-icon-mobile"></i>
                <div class="std-text-md std-text-blue-3 font-weight-bold">008</div>
              </v-col>
            </v-col>
            <!-- fin de contadores de vaquillas -->

            <!-- inicio de contadores de toros -->
            <v-col cols="4" class="d-flex">
              <v-col class="pa-1 mx-1 full-height d-flex align-center std-animal-count-container justify-space-between std-background-white-1">
                <i class="std-icon std-bull-blue-icon-mobile"></i>
                <div class="std-text-md std-text-blue-3 font-weight-bold">008</div>
              </v-col>
            </v-col>
            <!-- fin de contadores de toros -->

            <!-- inicio de botón de agregar vaca -->
            <v-col cols="4" class="d-flex">
              <v-col class="pa-0 mr-2 d-flex" no-padding>
                <v-btn class="pa-1 ml-2 full-height smartbell-greenButton-mobile d-flex justify-space-around"
                      depressed
                      elevation="3"
                      height="40px"
                      @click="openPage('CowForm')"
                      block
                      >
                      <img src="../assets/mini-icons/cow_table_white.svg" alt="#"
                           class="px-1"/>
                      <img src="../assets/Button_Add.svg" alt="#"
                           class="px-1"/>
                </v-btn>
              </v-col>
            </v-col>
            <!-- fin de botón de agregar vaca -->
        </v-row>
        <!-- fin de contadores de animales -->

        <!-- inicio de barra de busqueda -->
        <v-row no-gutters
               class="upper-cow-item">
          <!-- inicio de campo de texto --> 
          <v-col class="pa-0 ma-0 col-10 d-flex upper-cow-item">
            <v-col class="pa-0 col-12 d-flex">
                <v-text-field
                    outlined
                    clearable
                    placeholder="ID Vaca"
                    append-icon="search"
                    v-model="searchText"
                    dense/>
            </v-col>
          </v-col>
          <!-- fin de campo de texto -->


          <!-- inicio boton de filtros -->
          <v-col cols="2" class="d-flex">
            <v-col class="pa-0 mr-2 d-flex" no-padding>
              <v-btn class="pa-0 ml-2 full-height d-flex"
                outlined
                color="grey lighten-1"
                height="40px"
                block>
                  <img src="../assets/Icon_Filter.svg" alt="#"
                       class="px-0"/>
              </v-btn>
            </v-col>
          </v-col>
          <!-- fin boton de filtros -->
        </v-row>
        <!-- fin de barra de busqueda -->

        <v-row no-gutters cols="12" class="px-3 py-0">

          <!-- header de tabla para vacas -->
          <div class="dsheader-table d-flex align-center justify-center col-12"
               :class="{'std-background-blue-2': animalType === 'cows'}"
               v-if="animalType === 'cows'">
            <div class="dsheader-item col-3 d-flex align-center" >
              <v-checkbox dense
                          label="ID Vaca"
                          dark
                          hide-details
              >
              </v-checkbox>
              <i class="std-vertical-arrow-icon"
                 @click="orderBy('idInternal', idOrderFlag)"
                 :class="{'icon-anim' : idSortedIcon}"
                 @animationend="idSortedIcon = false">
              </i>
            </div>
            <div class="dsheader-item col-2 d-flex justify-center align-center">
              Raza
              <i class="std-vertical-arrow-icon"
                     @click="orderBy('breed', breedOrderFlag)"
                     :class="{'icon-anim' : breedSortedIcon}"
                     @animationend="breedSortedIcon = false">
              </i>
            </div>
            <div class="dsheader-item col-2 d-flex justify-center align-center">
              Estado
              <i class="std-vertical-arrow-icon"
                       @click="orderBy('state', stateOrderFlag)"
                       :class="{'icon-anim' : stateSortedIcon}"
                       @animationend="stateSortedIcon = false">
              </i>
            </div>
            <div class="dsheader-item col-1 d-flex justify-center align-center pa-0">
              DIM
              <i class="std-vertical-arrow-icon"
                 @click="orderBy('dim', dimOrderFlag)"
                 :class="{'icon-anim' : dimSortedIcon}"
                 @animationend="dimSortedIcon = false">
              </i>
            </div>
            <div class="dsheader-item col-2 d-flex justify-center align-center">
              Grupo
              <i class="std-vertical-arrow-icon"
                 @click="orderBy('group', groupOrderFlag)"
                 :class="{'icon-anim' : groupSortedIcon}"
                 @animationend="groupSortedIcon = false">
              </i>
            </div>
            <div class="dsheader-item col-2 d-flex justify-center align-center">
              Acciones
            </div>
          </div>
          <!-- fin de header de tabla para vacas -->
        </v-row>
        
    </v-container>
</template>

<script>
    import ChangeRanch from '@/components/ChangeRanch.vue';
    import SystemCardCount from "../components/SystemCardCount";
    export default {
      name: 'MobileComponents',
        data () {
          return {
          }
      },
      components: {
        ChangeRanch,
        SystemCardCount
      },
      computed: {
      },
      methods: {
      },
      mounted () {
      }
    };
</script>
    
<style lang="css">
    @import '../style/MobileCowList.css';
    @import '../style/BaseStyle.css';